import React, { useState, useEffect } from "react";
import AuthService from "../../../../../api/AuthService";
import LoaderHelper from "../../../../../utils/Loader/LoaderHelper";
import { useLocation } from "react-router-dom";
import { useAlert } from "../../../../../context/AlertContext";
import PurchaseView from "../../../../../entities/DashboardPage/AccountingModule/Purchase/PurchaseView";

const ViewPurchase = () => {
  const { showAlert } = useAlert();
  const { state } = useLocation();
  const { rowItem, page } = state || {};
  const [loading, setLoading] = useState(false);
  const [bankData, setBankData] = useState([]);

  useEffect(() => {
    getAllBanks()
  }, []);

  const handleDownload = async () => {
    LoaderHelper.loaderStatus(true);

    setLoading(true)
    try {
      const result = await AuthService.handleDownloadQuote(rowItem?._id);
      if (!result) {
        setLoading(false);
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error");
      } else {
        const blob = new Blob([result], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `FileName.${"pdf"}`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        setLoading(false);

        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const getViewInvoice = async () => {
    const result = await AuthService.getQuoteView(rowItem?._id);
    return { __html: result };
  };

  const sentQuote = async () => {
    LoaderHelper.loaderStatus(true);
    setLoading(true)
    try {
      const result = await AuthService.sentQuote(rowItem?._id);
      if (result?.success === true) {
        getViewInvoice();
        setLoading(false)
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "success");
      } else {
        setLoading(false)
        LoaderHelper.loaderStatus(false);

        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false)
      LoaderHelper.loaderStatus(false);
    }
  };

  const getAllBanks = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.handleGetAllCompanyBankAccount();
      if (result?.success) {
        setBankData(result?.data?.bankAccounts);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleSubmitData = async (payload) => {
    LoaderHelper.loaderStatus(true);
    setLoading(true);
    try {
      const result = await AuthService.paidBillInvoice(rowItem?._id, payload);
      if (result?.success === true) {
        setLoading(false);
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "success");
      } else {
        setLoading(false);
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      LoaderHelper.loaderStatus(false);
      showAlert("An error occurred while processing your request", "error");
    }
  };

  const handleEditSubmitData = async (currentPaymentId, payload) => {
    LoaderHelper.loaderStatus(true);
    setLoading(true);
    try {
      const result = await AuthService.updateBillPayment(rowItem?._id, currentPaymentId, payload);
      if (result?.success === true) {
        setLoading(false);
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "success");
      } else {
        setLoading(false);
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      LoaderHelper.loaderStatus(false);
      showAlert("An error occurred while processing your request", "error");
    }
  };



  return (
    <PurchaseView handleDownload={handleDownload} handleShowPdf={getViewInvoice} getViewInvoice={getViewInvoice} handleSendBill={sentQuote} rowItem={rowItem} data={bankData} handleSubmitData={handleSubmitData} handleEditSubmitData={handleEditSubmitData}/>
  )
}

export default ViewPurchase;